import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-search-dropdown',
  templateUrl: './search-dropdown.component.html',
  styleUrls: ['./search-dropdown.component.css']
})
export class SearchDropdownComponent implements OnInit, OnDestroy {

  @Input() clearSearch: boolean = false;
  @Output() searchItem = new EventEmitter<any>();
  placeHolder: any;
  search = new FormControl('');
  private _obs: any;
  private _subscription: Subscription;

  constructor(private _dataSer: DataService) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'clearFilter') {
        this.search.reset();
      }
    });
  }

  ngOnInit(): void {
    this._obs = this.search.valueChanges
      .subscribe(data => {
        if (data !== null && ((data.length && data.substr(data.length - 1) !== ' ') || (!data.length))) {
          this.searchItem.emit(data);
        }
      });
  }

  ngOnChanges(): void {
    if (this.clearSearch) {
      this.search.reset();
    }
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    if (this._obs)
      this._obs?.unsubscribe();

  } 

}
